import { LOG_TAGS } from '@/modules/logger/domain/logger.constants';
import { getLoggerService } from '@/modules/logger/infrastructure/loggerService';
import { regionService } from '@/modules/region/domain/region.service';

export default function ({ store, query }) {
  // This action should run on client side only on router hook
  // it will just check the domain prefix and store it in vuex
  if (process.client) {
    const { logger } = getLoggerService();
    const { region } = query;

    if (regionService.isValidRegion(region)) {
      const regionCode = regionService.getRegionCode(region);
      store.commit('detected-country/SET_CURRENT_DOMAIN_PREFIX', regionCode);
    } else {
      if (region) {
        logger.warn('Invalid region detected in middleware', {
          tags: [LOG_TAGS.INVALID_REGION],
          region,
          queryParams: query,
        });
      }
      store.dispatch('detected-country/setCurrentDomainPrefix');
    }
  }
}
